import { render, staticRenderFns } from "./gestion-locative.vue?vue&type=template&id=5727c4a4"
import script from "./gestion-locative.vue?vue&type=script&lang=js"
export * from "./gestion-locative.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports